import React, { } from 'react';
import { ReactComponent as BRA } from "../assets/svg/bra.svg";
import { ReactComponent as USA } from "../assets/svg/usa.svg";


export function Header(ts) {
    const { i18n } = ts;
    const texto = i18n['t']
    const obj = i18n['i18n']
    return (
        // <button onClick={() => obj.changeLanguage('en')}>en</button>
        // <button onClick={() => obj.changeLanguage('br')}>br</button>
        <header className="text-gray-700 body-font border-b border-gray-200 bg-white sticky top-0 z-50">
            <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                <a className="flex title-font font-medium items-center hidden md:block  text-gray-900 mb-4 md:mb-0" href="#" >
                    <span className="ml-3 text-xl">WB</span>
                </a>
                <nav className="md:ml-auto flex flex-wrap  md:hidden items-center text-base justify-center">
                    <a onClick={() => obj.changeLanguage('br')}><BRA className="w-10" /></a>
                    <a onClick={() => obj.changeLanguage('en')}><USA className="w-5 mr-10" /></a>
                </nav>
                <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
                    <a onClick={() => obj.changeLanguage('br')}><BRA className="w-10 hidden md:block cursor-pointer" /></a>
                    <a onClick={() => obj.changeLanguage('en')}><USA className="w-5 mr-10 hidden md:block cursor-pointer" /></a>
                    <a href="#home" className="mr-5 hover:text-gray-900"> {texto('home')}</a>
                    <a href="#about" className="mr-5 hover:text-gray-900"> {texto('about')}</a>
                    <a href="#articles-projects" className="mr-5 hover:text-gray-900"> {texto('project')}</a>
                    <a href="#contact" className="mr-5 hover:text-gray-900">{texto('contact')}</a>
                </nav>
            </div>
        </header>
    )
}
